<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
    <portal-target name="app-portal-target"></portal-target>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig';

export default {
  data() {
    return {
      vueAppClasses: [],
      modalObserver: null,
    };
  },
  watch: {
    '$store.state.theme': function (val) {
      this.toggleClassInBody(val);
    },
    '$vs.rtl': function (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr');
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    this.initModalObserver();

    // Removed global scroll listener that was auto-closing dropdowns on scroll
    // This was causing iOS elastic scrolling issues (bounce-to-top behavior)
    // Users can close dropdowns by clicking elsewhere or opening another dropdown
  },
  async created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('click', this.handleClick);
  },
  beforeUnmount() {
    if (this.modalObserver) {
      this.modalObserver.disconnect();
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('click', this.handleClick);
  },
  methods: {
    initModalObserver() {
      const observer = new MutationObserver(() => {
        this.toggleBodyScroll();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'], // solo si tus modales cambian estilos o clases
      });

      this.modalObserver = observer;

      // Primera comprobación por si ya hay modales abiertos
      this.toggleBodyScroll();
    },

    toggleBodyScroll() {
      const modals = document.querySelectorAll('.vs-component.con-vs-popup');
      const hasVisibleModal = Array.from(modals).some((modal) => getComputedStyle(modal).display !== 'none');
      document.body.classList.toggle('modal-open', hasVisibleModal);
    },

    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY);
    },
    handleClick($event) {
      const $firstOffsetParent = $event.target.offsetParent;
      const $secondOffsetParent = $firstOffsetParent ? $firstOffsetParent.offsetParent : null;

      if ($firstOffsetParent) {
        const $parent = $firstOffsetParent.parentElement;
        if ($firstOffsetParent.classList.contains('vs-dropdown--menu')
          || ($parent && $parent.classList.contains('vs-dropdown--menu'))) {
          document.body.click();
        }
      } else if ($secondOffsetParent && $secondOffsetParent.classList.contains('vs-dropdown--menu')) {
        const $parent = $secondOffsetParent.parentElement;
        if ($secondOffsetParent.classList.contains('vs-dropdown--menu')
          || ($parent && $parent.classList.contains('vs-dropdown--menu'))) {
          document.body.click();
        }
      }
    },
  },
};

</script>

<style>
/* Esto bloquea el scroll cuando hay un modal abierto */
body.modal-open {
  overflow: hidden;
}
</style>
